import Switch from 'react-switch'
import { useTranslation } from 'next-i18next'

import ModalLayout from 'components/commons/layouts/ModalLayout'
import ModalCloseButton from '../../buttons/ModalCloseButtonComponent'

import styles from './SearchFilterModal.module.scss'

interface Props {
  isVisibleSearchFilterModal: boolean
  onPressCloseModalRequest: () => void
  checkedFilterItems: object
  selectSearchParameters: (checked: boolean, id: string) => void
  onPressSearchFilter: () => void
}

const SearchFilterModal: React.FC<Props> = ({
  isVisibleSearchFilterModal,
  onPressCloseModalRequest,
  checkedFilterItems,
  selectSearchParameters,
  onPressSearchFilter,
}: Props): JSX.Element => {
  const { t } = useTranslation()
  const filters = [
    {
      name: 'has_wifi',
      label: t('SPACES.SEARCH.FILTER.HAS_WIFI'),
      icon: '/has_wifi_icon.svg',
      meta: t('META.HAS_WIFI_ICON'),
    },
    {
      name: 'has_charge',
      label: t('SPACES.SEARCH.FILTER.HAS_CHARGE'),
      icon: '/has_charge_icon.svg',
      meta: t('META.HAS_CHARGE_ICON'),
    },
    {
      name: 'available_in_english',
      label: t('SPACES.SEARCH.FILTER.AVAILABLE_IN_ENGLISH'),
      icon: '/available_in_english_icon.svg',
      meta: t('META.AVAILABLE_IN_ENGLISH_ICON'),
    },
    {
      name: 'no_smoking',
      label: t('SPACES.SEARCH.FILTER.NO_SMOKING'),
      icon: '/no_smoking_icon.svg',
      meta: t('META.NO_SMOKING_ICON'),
    },
    {
      name: 'has_elevator',
      label: t('SPACES.SEARCH.FILTER.HAS_ELEVATOR'),
      icon: '/has_elevator_icon.svg',
      meta: t('META.HAS_ELEVATOR_ICON'),
    },
    {
      name: 'available_24_hour',
      label: t('SPACES.SEARCH.FILTER.OPEN_24_HOURS'),
      icon: '/open_24_hours_icon.svg',
      meta: t('META.OPEN_24_HOURS_ICON'),
    },
    {
      name: 'can_book_on_the_day',
      label: t('SPACES.SEARCH.FILTER.CAN_BOOK_ON_THE_DAY'),
      icon: '/can_book_on_the_day.svg',
      meta: t('META.CAN_BOOK_ON_THE_DAY_ICON'),
    },
  ]

  return (
    <ModalLayout
      openModal={isVisibleSearchFilterModal}
      onPressCloseModalRequest={onPressCloseModalRequest}
      modalStyle={styles.modal}
      overlayClassName={styles.modalOverlay}
    >
      <div className={styles.filterContents}>
        <ModalCloseButton onPressCloseModalRequest={onPressCloseModalRequest} />
        <ul className={styles.filterContentsList}>
          {filters.map((filter, index) => (
            <li className={styles.filterContentsListItem} key={index}>
              <div className={styles.filterContentsListItemLabel}>
                <img src={filter.icon} alt={filter.meta} />
                <p>{filter.label}</p>
              </div>
              <label htmlFor={filter.name}>
                <Switch
                  id={filter.name}
                  checked={checkedFilterItems[filter.name] || false}
                  onChange={(checked, _, id) => selectSearchParameters(checked, id)}
                  onColor={styles.onColor}
                  offColor={styles.offColor}
                  offHandleColor={styles.offHandleColor}
                  uncheckedIcon={false}
                  checkedIcon={
                    <div className={styles.checkedIcon}>
                      <img src="/checked_icon.svg" alt={t('META.CHECKED_ICON')} />
                    </div>
                  }
                  width={48}
                  height={24}
                  handleDiameter={20}
                  className={styles.toggleSwitch}
                />
              </label>
            </li>
          ))}
        </ul>
      </div>
      <div className={styles.button}>
        <button className={styles.filterButton} onClick={onPressSearchFilter}>
          {t('SPACES.SEARCH.FILTER.SEARCH_BUTTON')}
        </button>
      </div>
    </ModalLayout>
  )
}

export default SearchFilterModal
